import { useEffect } from "react";
import { useTranslation } from "react-i18next";

function DaysInput(props: any) {
  const { value, formContext } = props;
  const { t } = useTranslation();

  const { element, setElement } = formContext;

  // ¡¡¡¡¡IMPORTANT!!!!! - Si se modifica este algoritmo hay que modificar también el atributo days de la entidad Booking ¡¡¡¡¡IMPORTANT!!!!!
  useEffect(() => {
    let diffDays = 0;
  
    if (element.start_date_time && element.end_date_time) {
      const start = new Date(element.start_date_time);
      const end = new Date(element.end_date_time);
  
      // Ajustamos la fecha de inicio a las 12:00 PM del día correspondiente
      const firstNoon = new Date(start);
  
      if (start.getHours() < 12) {
        // Si la hora es antes de las 12 PM, ajustamos a las 12 PM del día anterior
        firstNoon.setDate(firstNoon.getDate() - 1);
      }
      // Establecemos siempre las 12:00 PM
      firstNoon.setHours(12, 0, 0, 0);
  
      if (end > firstNoon) {
        // Calculamos los días adicionales a partir de las 12:00 PM del día de inicio
        const timeDifference = end.getTime() - firstNoon.getTime();
        const additionalDays = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
  
        // Sumamos los días adicionales
        diffDays += additionalDays;
      }
    }
  
    setElement((prevElement: any) => ({
      ...prevElement,
      days: diffDays,
    }));
  }, [element.start_date_time, element.end_date_time]);
  
  
  
  
  

  return (
    <>
      <br></br>
      <div>
        {value} {t("days")}
      </div>
    </>
  );
}

export default DaysInput;
